module.exports = __webpack_public_path__ + "static/media/climate-change-food.c05d184b.jpg";